module.exports = __webpack_public_path__ + "img/b14ee78.png";